(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rooted-section"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.main_rooted').forEach(card => {
    const para = card.querySelector('p');
    const text = para.getAttribute('data-text');
    let typingInterval;

    function startTyping() {
        let i = 0;

        clearInterval(typingInterval);
        para.innerHTML = "";
        para.style.opacity = "1";

        typingInterval = setInterval(() => {
            if (i < text.length) {
                para.innerHTML += text.charAt(i);
                i++;
            } else {
                clearInterval(typingInterval);
            }
        }, 25);
    }

    function resetTyping() {
        clearInterval(typingInterval);
        para.innerHTML = "";
        para.style.opacity = "0";
    }

    // Desktop only
    if (window.innerWidth > 767) {
        card.addEventListener('mouseenter', startTyping);
        card.addEventListener('mouseleave', resetTyping);
    }

    // Mobile only
    if (window.innerWidth <= 767) {
        card.addEventListener('click', function () {

            document.querySelectorAll('.main_rooted p').forEach(otherPara => {
                if (otherPara !== para) {
                    otherPara.innerHTML = "";
                    otherPara.style.opacity = "0";
                }
            });

            if (para.style.opacity === "1") {
                resetTyping();
            } else {
                startTyping();
            }
        });
    }
});

  } catch(e) { console.error(e); }
})();
})();
